"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Button } from "./ui/button"

export default function MonthlyMuse() {
  const [timeLeft, setTimeLeft] = useState({
    days: 30,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newSeconds = prevTime.seconds - 1

        if (newSeconds < 0) {
          const newMinutes = prevTime.minutes - 1

          if (newMinutes < 0) {
            const newHours = prevTime.hours - 1

            if (newHours < 0) {
              const newDays = prevTime.days - 1
              return {
                days: newDays < 0 ? 30 : newDays,
                hours: 23,
                minutes: 59,
                seconds: 59,
              }
            }

            return {
              ...prevTime,
              hours: newHours,
              minutes: 59,
              seconds: 59,
            }
          }

          return {
            ...prevTime,
            minutes: newMinutes,
            seconds: 59,
          }
        }

        return {
          ...prevTime,
          seconds: newSeconds,
        }
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])
  return (
    <section className="relative h-screen overflow-hidden">
      <img
        src="/kyoto.jpg?height=1080&width=1920"
        alt="Kyoto Daybed"
        className="absolute top-0 left-0 h-full w-full object-cover"
      />

      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="mb-2 font-serif text-xl uppercase tracking-widest">The One to Watch</h2>
          <h3 className="mb-8 font-serif text-5xl font-light md:text-7xl">The Kyoto Daybed</h3>

          <p className="mx-auto mb-8 max-w-xl text-lg md:text-xl">
            A masterpiece of craftsmanship, featuring hand-woven rattan and sustainably sourced teak. Only 50 pieces.
            Only this month.
          </p>

          <div className="mb-10 flex justify-center gap-6 text-center">
            {[
              { label: "Days", value: timeLeft.days },
              { label: "Hours", value: timeLeft.hours },
              { label: "Minutes", value: timeLeft.minutes },
              { label: "Seconds", value: timeLeft.seconds },
            ].map((item) => (
              <div key={item.label}>
                <div className="text-3xl font-light md:text-5xl">{item.value.toString().padStart(2, "0")}</div>
                <div className="text-xs uppercase tracking-wider text-stone-300">{item.label}</div>
              </div>
            ))}
          </div>

          <Button
            size="lg"
            className="rounded-none border border-white bg-transparent px-8 text-lg hover:bg-white hover:text-black"
          >
            Reserve Now
          </Button>
        </motion.div>
      </div>
    </section>
  )
} 